// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x-aJ","placeholdersHeader":"styles_placeholdersHeader__2tbmT","editorStyle":"styles_editorStyle__3KECD","placeholdersBox":"styles_placeholdersBox__39-Mo"};